"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";

export default function NotFound() {
    const t = useTranslations();

    return (
        <main className="min-h-screen flex items-center justify-center bg-[#1c1c1f]">
            <div className="text-center px-4">
                <h1 className="text-6xl font-bold text-white mb-4">{t("notFound.title")}</h1>
                <h2 className="text-2xl font-semibold text-[#A8A8AC] mb-4">
                    {t("notFound.heading")}
                </h2>
                <p className="text-[#78787E] mb-8 max-w-md">
                    {t("notFound.description")}
                </p>
                <Link
                    href="/"
                    className="inline-block px-6 py-3 bg-[#B1F4AB] text-[#1c1c1f] rounded hover:opacity-90 transition-colors font-medium"
                >
                    ← {t("notFound.backHome")}
                </Link>
            </div>
        </main>
    );
}
